import { useMutation } from '@tanstack/react-query';

import {
  type AiCodeContext,
  type AiCodeProposal,
  prepareAiCodeProposal,
  saveAiCodeProposal,
} from '~/services/PromoVoucherAiService';

export function usePromoVoucherAiWorkflow() {
  const generate = useMutation({
    mutationFn: (context: AiCodeContext) => prepareAiCodeProposal(context),
    retry: false,
  });
  const save = useMutation({
    mutationFn: (proposal: AiCodeProposal) => saveAiCodeProposal(proposal),
    retry: false,
  });

  return { generate, save };
}
